import React, { useState } from 'react';
import { isEmpty } from 'lodash-es';
import cx from 'classnames';
import { Modal } from '@mui/material';

import { ProfileIcon } from '../assets/icons';

import styles from './ProfileImage.module.css';

interface ProfileImageProps {
  photo: string;
  className?: string;
  disableClick?: boolean;
}

const ProfileImage = ({ photo, className = '', disableClick = false }: ProfileImageProps) => {
  const [openModal, setOpenModal] = useState(false);

  const toggleModal = (ev: React.MouseEvent<HTMLElement>) => {
    if (disableClick) return;
    
    ev.stopPropagation();
    setOpenModal(!openModal);
  };
  return (
    <>
      {!isEmpty(photo) ? (
        <div onClick={toggleModal} className={cx(styles.imageWrapper, className)} aria-hidden="true"><img className={styles.image} src={photo} alt="" /></div>
      ) : (
        <ProfileIcon className={cx(styles.icon, className)} />
      )}
      <Modal
        open={openModal}
        onClose={toggleModal}
        closeAfterTransition
      >
        <div className={styles.modalWrapper}>
          <img className={styles.image} src={photo} alt="" />
        </div>
      </Modal>
    </>
  );
};

export default ProfileImage;
